<template>
  <div>
    <v-card class="mx-auto mt-4 pr-2 hidden-md-and-down template-item" max-width="100%" outlined>
      <v-list-item three-line>
        <v-list-item-avatar tile size="110">
          <v-img
            v-if="template.ApplicationIconPath"
            :src="require(`@/assets/${template.ApplicationIconPath}`)"
          ></v-img>
          <v-img
            v-else-if="template.ProviderIconPath"
            :src="require(`@/assets/${template.ProviderIconPath}`)"
          ></v-img>
          <v-img v-else :src="require('@/assets/placeholder.png')"></v-img>
        </v-list-item-avatar>

        <v-list-item-content>
          <div class="overline" id="iteration-style">Id: {{template.Id || template.ConnectedId }}</div>

          <v-flex lg8>
            <v-list-item-title class="headline mb-2 title" id="title-style">
              {{ template.TemplateName }}
              <v-chip small outlined class="ml-2 info-chip">{{ template.Type }}</v-chip>
              <v-chip small outlined class="ml-2 connected-chip" v-if="template.ConnectedId">CONNECTED</v-chip>
              <template v-for="provider in template.Providers" >
                <v-chip :key="provider" small outlined :class="'ml-2 ' + provider + '-chip'">
                  {{  {
                    'az': 'Azure',
                    'aws': 'AWS',
                    'gcp': 'GCP'
                    }[provider]
                  }}
                </v-chip>
              </template>
              <!-- <v-chip small outlined class="ml-2 aws-chip" >AWS</v-chip>
              <v-chip small outlined class="ml-2 az-chip" >Azure</v-chip>
              <v-chip small outlined class="ml-2 gcp-chip" >GCP</v-chip> -->
            </v-list-item-title>
          </v-flex>

          <v-flex lg4 text-right>
            <v-btn v-if="template.Id" class="text-none" id="run-btn-style" :to="`/environments/${template.Id}/run`">
              <v-icon left>fas fa-cloud-upload</v-icon>Create
            </v-btn>
            <v-btn v-else class="text-none" id="run-btn-style" :to="`/environments/${template.ConnectedId}/run/connected`">
              <v-icon left>fas fa-cloud-upload</v-icon>Create
            </v-btn>
          </v-flex>

          <v-flex d-flex justify-start mt-4>
            <!-- <v-chip v-for="(tag, index) in template.tags" :key="tag" :class="{ 'ml-2': index > 0 }">{{ tag }}</v-chip> -->
            <v-chip>{{ template.ApplicationName }}</v-chip>
            <v-chip class="ml-2">{{ template.ApplicationProviderName }}</v-chip>
          </v-flex>
          <v-flex d-flex justify-end mt-4>
            <v-btn
              v-if="template.ReleaseNotes != 0"
              :href="template.ReleaseNotes"
              target="_blank"
              class="action-button"
              text
            >
              Release Notes
              <v-icon right id="icon-style">fas fa-external-link-alt</v-icon>
            </v-btn>
            <v-btn :href="`mailto:${template.CreatorEmailAddress}`" class="action-button" text>
              {{ template.CreatorEmailAddress }}
              <v-icon right id="icon-style">far fa-envelope</v-icon>
            </v-btn>
          </v-flex>
        </v-list-item-content>
      </v-list-item>
    </v-card>
  </div>
</template>

<script>
export default {
  data: () => ({
    showPublishUnpublishDialog: false,
  }),
  props: ["template"]
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css?family=Montserrat&display=swap");

.template-item {
  box-shadow: 0 0 14px -8px rgba(0, 0, 0, 0.4);
  border-radius: 20px;
}

div {
  font-family: "Montserrat";
}

.actions {
  background: #f9f9f9;
}

.card-actions,
.action-button {
  text-align: left;
  font: Regular 16px/19px Montserrat;
  letter-spacing: 0;
  color: #121212;
  opacity: 1;
  text-transform: none;
}

.action-button:nth-child(2) {
  padding: 0 5px !important;
}

#run-btn-style {
  background-color: #6db42c !important;
  font-size: 0.9em;
  border-radius: 16px;
  width: 103px;
  height: 32px;
  font: 15px/19px "Montserrat" !important;
  text-transform: none;
}

#run-btn-style .v-icon {
  padding-left: 6px;
}

#icon-style {
  color: #d0398b;
}

#title-style {
  font: bold 16px/19px "Montserrat" !important;
  text-align: left;
}

#iteration-style {
  opacity: 1;
  color: #888888;
  text-align: left;
  font: 12px/15px "Montserrat" !important;
  letter-spacing: 0 !important;
}

.info-chip {
  color: #881e98;
  font-weight: bold;
  font-size: 0.7rem;
  border-color: #881e98 !important;
  height: 18.5px;
}

.connected-chip {
  color: #ec0625;
  font-weight: bold;
  font-size: 0.7rem;
  border-color: #ec0625 !important;
  height: 18.5px;
}

.az-chip {
  color: #027dff;
  font-weight: bold;
  font-size: 0.7rem;
  border-color: #027dff !important;
  height: 18.5px;
}

.aws-chip {
  color: #ff9900;
  font-weight: bold;
  font-size: 0.7rem;
  border-color: #ff9900 !important;
  height: 18.5px;
}

.gcp-chip {
  color: #34a853;
  font-weight: bold;
  font-size: 0.7rem;
  border-color: #34a853 !important;
  height: 18.5px;
}

.dropdown {
  background: #eeeeee !important;
  box-shadow: none;
}

.dropdown-item:hover {
  background: #eeeeee;
  cursor: pointer;
}

.v-menu {
  z-index: 10000;
}
</style>